import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { confirmAndLogout } from "../utils/session";
import CampanaNotificaciones from "../components/CampanaNotificaciones";

const Supervisora = () => {
  const navigate = useNavigate();
  // Novedades del catálogo sin ver (solo un número en el botón "Compras"; el
  // detalle está dentro de Compras para no cargar el panel principal)
  const [novedades, setNovedades] = useState(0);
  // Reportes pendientes (diario + residentes + sustituciones): hoy y retrasados, en rojo sobre el botón «Reportes»
  const [pendReportes, setPendReportes] = useState(null);
  useEffect(() => {
    let vivo = true;
    axios.get("/api/tareas/resumen").then((r) => { if (vivo) setPendReportes(r.data); }).catch(() => {});
    return () => { vivo = false; };
  }, []);
  useEffect(() => {
    let vivo = true;
    axios.get("/api/productos/novedades/contador")
      .then((r) => { if (vivo) setNovedades(r.data?.pendientes || 0); })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);
  // read a simple user identifier saved by Login (sessionStorage or localStorage)
  const getUserString = () => {
    try {
      const s = sessionStorage.getItem('user') || localStorage.getItem('user') || '';
      if (!s) return '';
      // sometimes Login stores a JSON object; try parse and extract common fields
      try {
        const o = JSON.parse(s);
        return (o.user || o.id || o.email || o.usuario || o.username || '') + '';
      } catch (_) {
        return s + '';
      }
    } catch (_) { return ''; }
  };

  const handleLogout = () => {
    // Use centralized logout to preserve notification/device keys
    confirmAndLogout(navigate, '/login');
  };

  const options = [
    {
      title: "Compras",
      image: "/images/compras.png",
      action: () => navigate("/supervisora/compras"),
      subtitulo: novedades ? `🆕 ${novedades} novedad${novedades !== 1 ? "es" : ""} en productos` : null,
    },
    {
      title: "Servicios",
      image: "/images/servicios.png",
      action: () => navigate("/supervisora/servicios"),
    },
    {
      title: "Reportes",
      emoji: "📝",
      action: () => navigate("/supervisora/reportes"),
      pendientes: pendReportes ? (pendReportes.total_hoy || 0) + (pendReportes.total_retrasados || 0) : 0,
      subtituloRojo: pendReportes && (pendReportes.total_hoy || pendReportes.total_retrasados)
        ? [pendReportes.total_hoy ? `${pendReportes.total_hoy} hoy` : null, pendReportes.total_retrasados ? `${pendReportes.total_retrasados} retrasados` : null].filter(Boolean).join(" · ")
        : null,
    },
    {
      title: "Reporte diario",
      image: "/images/estadisticas.png",
      action: () => navigate("/supervisora/reporte-diario"),
    },
    {
      title: "Análisis Asistentas",
      image: "/images/estadisticas.png",
      action: () => navigate("/supervisora/analisis-asistentas"),
    },
    {
      title: "Estado de Pisos",
      image: "/images/estadisticas.png",
      action: () => navigate("/supervisora/analisis-pisos"),
    },
    {
      title: "Análisis Alumnos",
      image: "/images/gestion_usuarios.png",
      action: () => navigate("/supervisora/analisis-alumnos"),
    },
  ];
 

  return (
    <div style={{ ...styles.container, position: 'relative' }}>
      <div style={{ position: 'absolute', top: 12, left: 12, right: 12, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', zIndex: 50 }}>
        <button
          onClick={handleLogout}
        style={{
          padding: '12px 16px',
          borderRadius: 10,
          backgroundColor: '#ef4444',
          color: '#fff',
          border: 'none',
          cursor: 'pointer',
          fontWeight: 800,
          fontSize: 14,
        }}
        title="Cerrar sesión"
      >
        Cerrar sesión
      </button>
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, marginTop: 64, marginBottom: 24 }}>
        <h1 style={{ ...styles.title, marginTop: 0, marginBottom: 0 }}>
          Panel de Supervisora de{" "}
          <strong style={{ color: "#007bff" }}>{getUserString()}</strong>
        </h1>
        <CampanaNotificaciones rol="supervisora" usuario={getUserString()} conActivarPush conPermisos />
      </div>
      {/* Fichaje unificado (mismo botón y flujo que la asistenta): lo gestiona components/FichajePiso.js */}
      <div style={{ maxWidth: 520, margin: "0 auto 24px", padding: "0 12px", boxSizing: "border-box" }}>
        <button
          onPointerDown={() => window.dispatchEvent(new Event("fichaje:precalentar"))}
          onClick={() => window.dispatchEvent(new Event("fichaje:abrir"))}
          style={{
            display: "block", width: "100%",
            background: "linear-gradient(135deg, #1e3a5f, #2d4f7c)",
            border: "none", borderRadius: 18, padding: "20px",
            color: "#fff", fontSize: 22, fontWeight: 900, cursor: "pointer",
            boxShadow: "0 5px 18px rgba(30,58,95,0.4)", letterSpacing: "0.3px",
          }}
        >
          📷 Fichar
        </button>
      </div>
      <div style={styles.buttonContainer}>
        {options.map((option) => (
          <button
            key={option.title}
            onClick={() => {
              if (option.action) {
                option.action();
              } else if (option.path) {
                navigate(option.path);
              }
            }}
            style={{ ...styles.button, position: "relative" }}
          >
            {option.pendientes > 0 && (
              <span style={{ position: "absolute", top: -12, right: -8, minWidth: 30, height: 30, padding: "0 8px", boxSizing: "border-box", borderRadius: 999, background: "#dc2626", color: "#fff", fontWeight: 900, fontSize: 16, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(220,38,38,0.5)", border: "2px solid #fff" }}>{option.pendientes}</span>
            )}
            {option.emoji
              ? <span style={{ ...styles.image, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 42 }}>{option.emoji}</span>
              : <img
                  src={option.image}
                  alt={option.title}
                  style={styles.image}
                />}
            <span style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
              <span style={styles.label}>{option.title}</span>
              {option.subtituloRojo && (
                <span style={{
                  background: "#fee2e2", color: "#b91c1c", border: "1px solid #fca5a5",
                  borderRadius: 999, padding: "3px 10px", fontSize: 13, fontWeight: 800, whiteSpace: "nowrap",
                }}>🔴 {option.subtituloRojo}</span>
              )}
              {option.subtitulo && (
                <span style={{
                  background: "#dcfce7", color: "#15803d", border: "1px solid #86efac",
                  borderRadius: 999, padding: "3px 10px", fontSize: 13, fontWeight: 800, whiteSpace: "nowrap",
                }}>{option.subtitulo}</span>
              )}
            </span>
          </button>
        ))}

      </div>
    </div>
  );
};


const styles = {
  container: {
    textAlign: "center",
    padding: "40px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  title: {
    marginBottom: "30px",
    color: "#333",
    marginTop: 80,
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    alignItems: "center",
  },
  button: {
    backgroundColor: "transparent",
    width: "90%",
    maxWidth: "400px",
    padding: "20px",
    border: "2px solid #007bff",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center", // Centra horizontalmente
    gap: "20px",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
  },
  image: {
    width: "50px",
    height: "50px",
    objectFit: "contain",
  },
  label: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#007bff",
    textAlign: "center",
  },
};

export default Supervisora;
